export default {
    id: 'red-blue',
    colors: ['#BA2534', '#1B6DD1'],
};
